import { GrowthBook } from '@growthbook/growthbook'

export default defineNuxtPlugin({
  name: 'growthbook',

  dependsOn: ['store', 'keycloak'],

  async setup() {
    const config = useRuntimeConfig()

    const { $keycloakReadyPromise, $store } = useNuxtApp()
    // Wait for keycloak to finish init
    await $keycloakReadyPromise

    const userData = $store.auth.authenticatedUser
    const subdomain = $store.companies.subdomain

    const gbInstance: GrowthBook = new GrowthBook({
      clientKey: config.public.growthbookClientKey,
      enableDevMode: true,
      attributes: {
        id: userData.id,
        tenantSubdomain: subdomain,
      },
    })

    try {
      await gbInstance.init({ streaming: true })
    }
    catch (e) {
      console.error('Error initializing GrowthBook:', e)
    }

    return {
      provide: {
        growthbook: gbInstance,
      },
    }
  },
})
